import { FinancialYearContent } from "../../components/configuration";

export default function FinancialYear() {
  return (
    <>
      <FinancialYearContent />
    </>
  );
}
